import { set } from 'lodash';

import { toast } from '@hivebrite/design-system/Toast';

import { TOPICS_QUERY_KEY } from 'hb-react/backoffice/constants/builder/builderApiKeys';
import type { FetchDynamicSearchByTypeArgs } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicSearch/types';
import type { ITopic } from 'hb-react/shared/apps/TopicsIndexV2/types';
import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance } from 'hb-react/shared/utils/axios';
import { APP_TYPE } from 'hb-react/types/appType';

export const useSearchTopics = ({
  app,
  enabled,
  flags,
  ids,
  networkId,
  onError,
  onSuccess,
  params,
  type,
}: FetchDynamicSearchByTypeArgs) => {
  const topicsURL =
    app === APP_TYPE.BACKOFFICE
      ? Routes.fetch_topics_backoffice_network_dynamic_components_search_index_path(
          networkId,
        )
      : Routes.fetch_topics_dynamic_components_search_index_path();
  const topicsQueryFn = async (): Promise<ITopic[]> => {
    if (app === APP_TYPE.BACKOFFICE) {
      set(params, 'query.user_id', null);
    }
    const { data } = await axiosInstance.get(topicsURL, {
      params: {
        ...params,
        ...ids,
      },
    });

    return data?.topics;
  };

  return useQueryOnce(
    [TOPICS_QUERY_KEY, app, params, ids.topic_id, networkId],
    topicsQueryFn,
    {
      enabled: enabled && type === 'topics' && flags?.flagsLoaded,
      onError: (error) => {
        toast.error(__('Sorry, an error occurred'));
        onError?.(error);
      },
      onSuccess,
    },
  );
};
